import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { TableHead } from "@/components/ui/table";
import { getAsset } from "@/lib/contentful/guards";
import { cn } from "@/lib/utils";
import { ContentfulHelper } from "@/utils/ContentfulHelper";
import type { ColumnHeaderEntry } from "./ComparisonTable";
interface Props {
  columnHeaderEntry: ColumnHeaderEntry;
}
export default function ComparisonTableColumnHeader(t0) {
  const $ = _c(14);
  const {
    columnHeaderEntry
  } = t0;
  let t1;
  if ($[0] !== columnHeaderEntry.fields.logo) {
    const logoAsset = getAsset(columnHeaderEntry.fields.logo);
    t1 = logoAsset ? ContentfulHelper.parseContentfulContentImage(logoAsset) : null;
    $[0] = columnHeaderEntry.fields.logo;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const contentImage = t1;
  const t2 = columnHeaderEntry.fields.emphasize ? "bg-(--primary) text-white" : "text-muted-foreground";
  let t3;
  if ($[2] !== t2) {
    t3 = cn("p-4", t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== contentImage) {
    t4 = contentImage && <Image src={contentImage.src} alt={contentImage.alt} width={contentImage.width || 80} height={contentImage.height || 40} className="h-8 w-auto" />;
    $[4] = contentImage;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== columnHeaderEntry.fields.name) {
    t5 = <span>{columnHeaderEntry.fields.name}</span>;
    $[6] = columnHeaderEntry.fields.name;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <div className="flex items-center gap-1">{t4}{t5}</div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t6) {
    t7 = <TableHead className={t3}>{t6}</TableHead>;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}